import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { FiLogIn } from "react-icons/fi";
import { CiEdit } from "react-icons/ci";


const TenantCard = ({ tenant, onDelete, onLogin, onEdit }) => {
    const sliceNum = 40;

    return (
        <div className="border-b overflow-visible relative justify-between overflow-hidden w-full px-3 pb-3 bg-white flex flex-col">
            {/* Header Section */}
            <div className="flex justify-between items-center w-full">
                <div className="flex flex-col items-start gap-1">
                    <p className="text-xl font-semibold text-slate-800">{tenant.title.length > sliceNum ? `${tenant.title.slice(0, sliceNum)}..` : tenant.title}</p>
                    <p className="text-xs text-slate-500">Login: {tenant.login}</p>
                </div>

                <div className='flex flex-row gap-6 relative'> 
                                
                    <button
                        className="h-6 w-6 flex justify-center items-center text-slate-600 hover:text-blue-500 rounded-full"
                        onClick={ () => onEdit(tenant.login) }
                    >
                        <CiEdit className="w-5 h-5" />
                    </button>


                    {/* Login Button with Tooltip */}
                    <div className="group relative">
                        <button
                            className="h-6 w-6 flex justify-center items-center text-slate-500 bg-slate-200 hover:bg-blue-500 hover:text-white rounded-full"
                            onClick={() => onLogin(tenant.login)}
                        >
                            <FiLogIn className="w-4 h-4" />
                        </button>
                        <div className="absolute w-28 text-center bottom-full left-1/2 transform -translate-x-1/2 mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-blue-500 text-white text-xs rounded py-1 px-2">
                            Login to account
                        </div>
                    </div>

                    {/* Delete Button */}
                    <button
                        className="h-6 w-6 flex justify-center items-center bg-slate-500 hover:bg-red-600 text-white rounded-full"
                        onClick={() => onDelete(tenant.login)}
                    >
                        <FaTimes className="w-4 h-4" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TenantCard;
